export default __webpack_public_path__ + "static/media/deleteActionsIcon.772e8d84.svg";